module.exports = __webpack_public_path__ + "img/epos4.c53f9287.jpg";